export default __webpack_public_path__ + "static/media/icon-mitigation-white.b63d1bc6.svg";